export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'https://fp5ivt2da6.execute-api.eu-north-1.amazonaws.com/prod/api';
const API_CREDENTIALS_MODE = process.env.REACT_APP_API_CREDENTIALS_MODE;

function buildRequestError(response, payload) {
  const error = new Error(payload.message ?? 'Request failed.');
  error.status = response.status;
  error.payload = payload;
  return error;
}

export async function request(path, { method = 'GET', headers, body } = {}) {
  return fetch(`${API_BASE_URL}${path}`, {
    method,
    ...(API_CREDENTIALS_MODE ? { credentials: API_CREDENTIALS_MODE } : {}),
    headers,
    body,
  });
}

export async function requestJson(path, { method = 'GET', headers, body } = {}) {
  const response = await request(path, {
    method,
    headers: {
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (response.status === 204) {
    return null;
  }

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(response, payload);
  }

  return payload;
}
